// extracted by mini-css-extract-plugin
export default {"date-row":"NewOrderDrawer_date-row__aHaBC","tagCol":"NewOrderDrawer_tagCol__plbuW"};